import { Button } from '@consta/uikit/Button'
import { selectActiveProjectName, useAppSelector } from '@core/core/store'
import type { DataAnalyticsId } from '@core/core/types'
import { getProjectNameCustomParams } from '@core/core/utils'
import { Delimiter } from '@library/components'
import cn from 'classnames'
import type { Prettify } from 'common/types'
import type { FC } from 'react'

import type { RibbonItem, RibbonItemsText } from '../../types'
import css from './ProjectToolbar.css'

type Props = {
  item: Prettify<RibbonItem & DataAnalyticsId>
  selectedRibbonItem?: RibbonItemsText
  setSelectedRibbonItem: (arg: RibbonItemsText) => void
  getActionFromRibbonItem: (arg: RibbonItemsText) => void
}

export const ToolbarItem: FC<Props> = ({
  item,
  selectedRibbonItem,
  setSelectedRibbonItem,
  getActionFromRibbonItem,
}) => {
  const activeProjectName = useAppSelector(selectActiveProjectName)
  const dataAnalyticParams = item.dataAnalyticsId
    ? getProjectNameCustomParams(activeProjectName)
    : undefined

  const onItemClick = () => {
    setSelectedRibbonItem(item.text)
    getActionFromRibbonItem(item.text)
  }
  const itemClassName = cn({
    [css.toolbarRibbonButtonColor]: selectedRibbonItem === item.text,
    [css.btnMargin]: item.margin,
  })
  return (
    <div key={item.text} className={css.container}>
      {!!item.delimiter && <Delimiter />}
      <Button
        id={item.text}
        className={itemClassName}
        label={item.text}
        iconLeft={item.icon}
        view="clear"
        size="xs"
        data-analytics-id={item.dataAnalyticsId}
        data-analytic-params={dataAnalyticParams}
        onClick={onItemClick}
      />
    </div>
  )
}
